import React from 'react';
import PropTypes from 'prop-types';
import TreeViewItem from './tree-view-item';
import { ListItem } from './constants/types';
import { NESTABLE, NONE, SORTABLE } from './constants/interaction-types';

function TreeViewList({
  items,
  move,
  find,
  nestingLevel,
  maxNestingLevel,
  interaction,
  onItemClick,
  onStartItemDrag,
  onEndItemDrag,
}) {
  const lastItemIndex = items.length - 1;

  return (
    <div className="ws-tree-view-list">
      {items.map((item, index) => (
        <TreeViewItem
          key={item.id}
          onItemClick={onItemClick}
          nestingLevel={nestingLevel}
          maxNestingLevel={maxNestingLevel}
          source={items}
          isLast={index === lastItemIndex}
          interaction={interaction}
          id={item.id}
          item={item}
          move={move}
          find={find}
          onStartItemDrag={onStartItemDrag}
          onEndItemDrag={onEndItemDrag}
        />
      ))}
    </div>
  );
}

TreeViewList.propTypes = {
  onItemClick: PropTypes.func.isRequired,
  nestingLevel: PropTypes.number.isRequired,
  maxNestingLevel: PropTypes.number.isRequired,
  move: PropTypes.func.isRequired,
  find: PropTypes.func.isRequired,
  interaction: PropTypes.oneOf([NONE, SORTABLE, NESTABLE]).isRequired,
  items: PropTypes.arrayOf(ListItem).isRequired,
  onStartItemDrag: PropTypes.func.isRequired,
  onEndItemDrag: PropTypes.func.isRequired,
};

export default TreeViewList;
